import { Component } from '@angular/core';

@Component({
  selector: 'icon-google-logo',
  templateUrl: './icon-google-logo.component.html',
  styleUrls: ['./icon-google-logo.component.scss']
})
export class IconGoogleLogoComponent {
}
